// extracted by mini-css-extract-plugin
module.exports = {"block":"WireHeader_block__dubRM","mobileSort":"WireHeader_mobileSort__wMnyd"};